/**
 * Story 052 — generic Section landmark wrapper.
 *
 * Each Settings section renders inside a <Box role="region"
 * aria-labelledby="{id}-heading"> so axe + screen readers report them
 * as distinct landmarks (AC1).
 */
import type { PropsWithChildren, ReactElement } from "react";
import { Box, Typography } from "@mui/material";

interface SectionShellProps {
  id: string;
  title: string;
}

export function SectionShell({
  id,
  title,
  children,
}: PropsWithChildren<SectionShellProps>): ReactElement {
  const headingId = `${id}-heading`;
  return (
    <Box
      component="section"
      id={id}
      role="region"
      aria-labelledby={headingId}
      sx={{
        py: 4,
        borderTop: (t) => `1px solid ${t.palette.divider}`,
        "&:first-of-type": { borderTop: "none" },
      }}
    >
      <Typography
        id={headingId}
        component="h2"
        variant="h5"
        sx={{ mb: 2, fontWeight: 600 }}
      >
        {title}
      </Typography>
      {children}
    </Box>
  );
}
